import Handsontable from 'handsontable';
import { isString } from 'lodash';
import { Thunk } from '../../../types/reduxTypes';
import { CellData, CellTypeObject, TableChangeSource } from '../../../../common/table/TableTypes';
import { CellTypeNames } from '../../../../common/table/CellTypeConstants';
import { updateCellType as updateCellTypeUtil } from '../utils/tableCellTypeUtils';
import { userCurrencyPreferenceSelector } from '../../../user/currentUserSelector';
import { ActiveTableSession } from '../store/hotTableStoreTypes';
import { updateActiveHotTableSelectionData } from '../utils/hotInstanceUtils/activeHotTableMutationUtils';

/**
 * Updates the cell type for all the selected cells in the table.
 */
// FIXME-TABLES - Ensure this flow no longer needs to update redux in the V2 architecture end state
export const updateTableCellType =
    ({
        hotInstance,
        session,
        elementId,
        cellType,
    }: {
        hotInstance: Handsontable;
        session: ActiveTableSession;
        elementId: string;
        cellType: CellTypeNames | CellTypeObject;
    }): Thunk =>
    (_, getState) => {
        const state = getState();
        const currencyPreference = userCurrencyPreferenceSelector(state);

        if (isString(cellType)) {
            updateActiveHotTableSelectionData({
                hotInstance,
                session,
                cellDataUpdateFn: (cellData: CellData, row?: number, col?: number) =>
                    updateCellTypeUtil(cellData, cellType, currencyPreference, elementId, row, col, hotInstance),
                tableUpdateSource: TableChangeSource.CELL_META_UPDATE_CELL_TYPE,
            });

            return;
        }

        updateActiveHotTableSelectionData({
            hotInstance,
            session,
            cellDataUpdateFn: (cellData: CellData) => ({
                ...cellData,
                type: cellType,
            }),
            tableUpdateSource: TableChangeSource.CELL_META_UPDATE_CELL_TYPE,
        });
    };
